<ui-icon faStyle="light" faName="circle-check"></ui-icon>
<div class="success-content">
  <h2>{{ data.title }}</h2>
  <p>
    <span [innerHTML]="(data.message + ' ') | bypassSecurity"></span>
    @if (data.action; as action) {
      <button [name]="action.name" type="submit">{{ action.label }}</button>
    }
  </p>
</div>
